export default __webpack_public_path__ + "static/media/Movie.45ffba76.png";